<template>
  <div>
    <BaseTitle :title="$t('content.score_title')" :yearPeriode="titleData" />
    <v-row>
      <v-col md="9" class="py-0">
        <v-card class="mb-7">
          <div class="pa-5">
            <v-btn color="primary" class="btn-primary-custom mb-10" :loading="table.loading" @click="getExport">{{ $t('content.export') }}</v-btn>
            <v-spacer />
            <v-data-table
              hide-default-footer
              show-expand
              :headers="headers"
              :items="items.assignments"
              :single-expand="true"
              :expanded.sync="expanded"
              :loading="table.loading"
              item-key="assignmentId"
              class="table-custom"
              ref="dTable"
              disable-pagination
            >
              <template #item.assignmentTitle="{ item }">
                <span
                  >{{ item.assignmentTitle }} <br /><b>{{ item.groupName }}</b></span
                >
              </template>
              <template #item.score="{item}">
                <span v-if="(item.score === 0 && item.published === false) || item.excused">-</span>
                <span v-else>{{ item.score }}</span>
              </template>

              <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
                <button
                  @click="
                    expand(item);
                    scoring(item);
                  "
                  v-if="!isExpanded && item.detailPublished === true"
                  type="button"
                  class="v-icon notranslate v-data-table__expand-icon v-icon--link mdi mdi-chevron-down theme--light"
                ></button>
                <button
                  @click="expand(false)"
                  v-if="isExpanded && item.detailPublished === true"
                  type="button"
                  class="v-icon notranslate v-data-table__expand-icon v-icon--link mdi mdi-chevron-down theme--light v-data-table__expand-icon--active"
                ></button>
              </template>

              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="pa-0">
                  <v-sheet color="grey lighten-2" class="pa-4" v-if="item.detailPublished === true">
                    <v-row>
                      <v-col md="2">
                        <b>{{ $t('content.score_detail') }}:</b>
                      </v-col>
                      <v-col md="2">{{ $t('content.mean') }}: {{ Math.round(hitung.mean) }}</v-col>

                      <v-col md="2">{{ $t('content.high') }}: {{ Math.round(hitung.max) }}</v-col>

                      <v-col md="2">{{ $t('content.low') }}: {{ Math.round(hitung.min) }}</v-col>
                      <v-col md="4">
                        <div class="d-flex justify-space-between" :color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'" flat tile>
                          <strong class="mr-2 mt-1">{{ $t('content.low') }} </strong>
                          <v-progress-linear :value="Math.round(hitung.progressBar)" height="23" style="border-radius: 9px;"> </v-progress-linear>
                          <strong class="ml-2 mt-1">{{ $t('content.high') }} </strong>
                        </div>
                      </v-col>
                    </v-row>
                  </v-sheet>
                  <v-sheet v-else>
                    No Data
                  </v-sheet>
                </td>
              </template>
              <template #no-data>
                {{ $t('data_not_available') }}
              </template>
            </v-data-table>

            <div v-for="assignmentGroups in items.assignmentGroups" v-bind:key="assignmentGroups.groupId">
              <div class="pa-5 d-flex justify-space-between">
                <strong class="ml-7">{{ assignmentGroups.groupName }}</strong>
                <div class="mr-4">
                  <strong v-if="assignmentGroups.scorePercentage === 0">-</strong>
                  <strong v-else>{{ assignmentGroups.scorePercentage }}%</strong>
                  <strong class="ml-16 mr-13" v-if="assignmentGroups.totalStudentScore === 0 && assignmentGroups.totalScore === 0">0</strong>
                  <strong class="ml-16 mr-13" v-else>{{ assignmentGroups.totalStudentScore }}/{{ assignmentGroups.totalScore }}</strong>
                </div>
              </div>
              <hr />
            </div>
            <v-card class="pa-5 d-flex justify-space-between section-footer">
              <strong class="ml-7">Total</strong>
              <strong class="mr-16" v-if="items.totalScore === 0">-</strong>
              <strong class="mr-16" v-else>{{ items.totalScore }}% </strong>
            </v-card>
          </div>
        </v-card>
      </v-col>
      <v-col md="3" class="py-0">
        <v-card class="mb-7">
          <div>
            <v-data-table hide-default-footer :headers="headersGrup" :items="items.groups" :loading="table.loading" class="table-custom">
              <template #item.groupWeight="{ item }">
                <span v-if="item.groupWeight === 0">-</span>
                <span v-else>{{ item.groupWeight }}</span>
              </template>
              <template #no-data>
                {{ $t('data_not_available') }}
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';

export default {
  name: 'ScoreIndex',
  components: {
    BaseTitle
  },
  computed: {
    ...mapGetters({
      role: 'Auth/currentRole',
      student: 'Auth/student',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    headers() {
      return [
        { text: '', value: 'data-table-expand' },
        { text: this.$t('form.name'), value: 'assignmentTitle' },
        { text: this.$t('content.due_date'), value: 'dueDate' },
        { text: this.$t('menu.score'), value: 'score' },
        { text: this.$t('content.out_of'), value: 'totalScore' }
      ];
    },
    headersGrup() {
      return [
        { text: this.$t('content.group_name_assignment'), value: 'assignmentGroupName' },
        { text: this.$t('content.group_weight_assignment'), value: 'groupWeight' }
      ];
    }
  },
  data: () => ({
    loading: false,
    expanded: [],
    dataClass: '',
    hitung: {
      mean: 0,
      max: 0,
      min: 0,
      progressBar: 0
    },
    table: {
      loading: true
    },
    items: '',
    datas: '',
    titleData: ''
  }),
  methods: {
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    fetchCourse() {
      this.$store.dispatch('Course/fetchList').catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    getData() {
      const { classId, courseId } = this.$route.params;
      this.$store
        .dispatch('Score/fetchList', { classId, courseId })
        .then(res => (this.items = res))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally((this.table.loading = false));
    },
    getDataParent() {
      const { classId, courseId } = this.$route.params;
      var studentId = this.student.studentId;
      this.$store
        .dispatch('Score/fetchListParent', { classId, courseId, studentId })
        .then(res => (this.items = res))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally((this.table.loading = false));
    },
    getDatas() {
      this.table.loading = true;
      this.$store
        .dispatch('Score/fetchListData')
        .then(res => (this.datas = res))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally((this.table.loading = false));
    },
    getExport() {
      if (this.role === 5) {
        const { classId, courseId } = this.$route.params;

        this.table.loading = true;
        this.$store
          .dispatch('Score/exportStudent', { classId, courseId })
          .then(response => {
            let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `student_report_assignment_${this?.dataClass?.classroomName}_${localStorage.getItem('courseName')}.xlsx`;
            link.click();
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally(() => (this.table.loading = false));
      } else {
        const { classId, courseId } = this.$route.params;

        var studentId = this.student.studentId;

        this.table.loading = true;
        this.$store
          .dispatch('Score/exportParent', { classId, courseId, studentId })
          .then(response => {
            let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `parent_report_assignment_${this?.dataClass?.classroomName}_${localStorage.getItem('courseName')}.xlsx`;
            link.click();
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally(() => (this.table.loading = false));
      }
    },
    downloadReport() {
      // console.info('Download Report');
    },
    scoring(item) {
      this.$store
        .dispatch('Assignment/fetchStudent', item.assignmentId)
        .then(res => {
          var sum = 0;
          for (var i = 0; i < res.length; i++) {
            sum += parseInt(res[i].score, 10); //don't forget to add the base
          }

          var avg = sum / res.length;
          this.hitung.mean = avg;
          this.hitung.max = Math.max.apply(
            Math,
            res.map(o => o.score)
          );
          this.hitung.min = Math.min.apply(
            Math,
            res.map(o => o.score)
          );

          this.hitung.progressBar = (item.score / this.hitung.max) * 100;

          // this.expanded[0].totalScore = Math.max(res.score);
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    }
  },
  created() {
    this.getDataClass();
    this.$store.commit('table/RESET_PAGEABLE');
    this.fetchCourse();
    if (this.role === 3) {
      this.getDataParent();
    } else if (this.role === 5) {
      this.getData();
    }
    // this.getDatas();
  }
};
</script>

<style lang="scss" scoped>
.section-footer {
  border-radius: 4px 4px 0 0;
  background: #e7f5ff;
}
.attendance-scroller {
  overflow-x: scroll;
  overflow-y: visible;
}

.attendance-table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  th {
    padding: 10px;
    text-align: left;
    color: #fff;
  }

  td {
    padding: 0px 13px;
    height: 50px;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    background: #fff;

    &:not(.attendance-sticky) {
      font-weight: bold;
      cursor: pointer;

      &:hover {
        background: #f8f8f8;
      }
    }
  }

  thead {
    tr {
      th {
        $height: 100px;
        height: $height;
        background: #00BF63;

        div {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;

          button {
            position: absolute;
            top: -5px;
            right: 0;
          }
        }
      }
    }
  }
}
</style>
